import { Component } from 'react'
import { Helmet } from 'react-helmet'

import { Switch, Redirect } from 'react-router-dom'
import Main from '../../containers/Main'
import RouteWithSubRoutes from '../../lib/RouteWithSubRoutes'

const HelmetSetting = ({ title }) => (
  <Helmet>
    <title>{title}</title>
  </Helmet>
)

class Item extends Component {
  componentDidMount () {
  }

  render () {
    const props = this.props
    const { name, routes } = props

    return (
      <Main
        routes={routes}
        render={(mainProps) => {
          return (
            <div data-role='item'>
              <HelmetSetting title={name} />
              <Switch>
                {
                  routes.map((route, i) => {
                    return (
                      <RouteWithSubRoutes
                        key={i}
                        {...route}
                        {...mainProps}
                        {...props}
                      />
                    )
                  })
                }
                {/* 預設導向到熱銷賣場頁面 */}
                <Redirect to='/item/bestSelling' />
              </Switch>
            </div>
          )
        }}
      />
    )
  }
}

export default Item
